import React, { useContext, useEffect, useState } from 'react'
import GlobalContext from '../../../../contexts/globalContext';
import { getToken, postSendOtp, postValidateOtp } from '../../../../services/mentoriaService';
import Button from '../../../atoms/button/button'
import MentoriaIconTitle from '../mentoria-icon-title/mentoriaIconTitle';
import MentoriaLoading from '../mentoria-loading/mentoriaLoading';
import './mentoriaOtp.scss';

const DURATION = 5 //5 minutos en segundos o 60 * 5

const MentoriaOtp = (props: any) => {

    const [code, setCode] = useState('');
    const [timer, setTimer] = useState(DURATION * 60);
    const [countdown, setCountdown] = useState<any>(null);
    const [loading, setLoading] = useState(false);
    const Context = useContext(GlobalContext);
    const { email } = Context?.gigyaContext?.gigyaAccount.profile;
    const { mobile } = Context?.gigyaContext?.gigyaAccount.data;
    const [error, setError] = useState('');

    const displayMobile = mobile.substring(0, 3) + '*'.repeat(6) + mobile.substring(9, 11);
    const displayEmail = email.substring(0, 2) + '*'.repeat(email.split('@')[0].length) + '@' + email.split('@')[1];
    const getTokenOtp = async () => {
        setError('');
        try {
            let token;
            if (Context.gigyaContext.gigyaAccount) {
                token = await getToken(Context.gigyaContext.gigyaAccount.UID);
            } else {
                return;
            }
            await postSendOtp(token.id_token, {
                "cellPhone": mobile,
                "email": email
            }).then(res => {
                if (res.data.status === 200) {
                    setTimer(res.data.data.lifeToken * 60);
                    setCountdown(setInterval(() => {
                        setTimer(prev => prev - 1);
                    }, 1000));
                } else {
                    setError('*Hubo un problema al generar el código OTP, intentalo nuevamente');
                    setTimer(0);
                }
            })

        } catch (error) {
            // console.error(error);
            setError('*Hubo un problema al generar el código OTP, intentalo nuevamente');
            setTimer(0);
        } finally {
            setLoading(false);
        }

    }

    const checkOtp = async () => {
        setError('');
        if (code == null || code == "") {
            setError('*No ingresaste ningún código');
        } else {
            try {
                let token;
                if (Context.gigyaContext.gigyaAccount) {
                    token = await getToken(Context.gigyaContext.gigyaAccount.UID);
                } else {
                    return;
                }
                postValidateOtp(token.id_token, {
                    cellPhone: mobile,
                    codeOtp: code,
                    email: email,
                }).then((res) => {
                    if (res.data.status === 200) {
                        // startDiagnostic();
                        props.handleCorrectCode();
                    } else {
                        setError('*El código que acabas de ingresar es incorrecto, verifica')
                    }
                });
            } catch (error) {
                // console.error(error);
                setError('Hubo un error validando el código, intentalo nuevamente');
            }
        }
    };

    useEffect(() => {
        setLoading(true);
        getTokenOtp();
        return (() => {
            clearInterval(countdown)
        });
    }, []);

    useEffect(() => {
        if (timer <= 0) {
            clearInterval(countdown);
            setTimer(0);
        }
    }, [timer])



    return (
        <div className="mentoria-otp">
            <MentoriaLoading open={loading} />
            <header className="mentoria-otp__header">
                <h2 className="mentoria-otp__header__title">Para aceptar el tratamiento de tus datos te acabamos de enviar un código a tu celular y a tu correo electrónico.</h2>
                <section className="mentoria-otp__header__section">
                    <div className="mentoria-otp__header__section__card">
                        <img className="mentoria-otp__header__section__card__img" src={props.otpIcons[2]} alt="Número de celular" />
                        <div className="mentoria-otp__header__section__card__container">
                            <p className="mentoria-otp__header__section__card__title">Número de celular</p>
                            <p className="mentoria-otp__header__section__card__subtitle">{displayMobile}</p>
                        </div>
                    </div>
                    <div className="mentoria-otp__header__section__card">
                        <img className="mentoria-otp__header__section__card__img" src={props.otpIcons[1]} alt="Correo electrónico" />
                        <div>
                            <p className="mentoria-otp__header__section__card__title">Correo electrónico</p>
                            <p className="mentoria-otp__header__section__card__subtitle">{displayEmail}</p>
                        </div>
                    </div>
                </section>
                <span className="mentoria-otp__header__datos-erroneos">Estos no son mis datos</span>
            </header>
            <main className="mentoria-otp__main">
                <p className="mentoria-otp__main__title">Una vez recibido ingrésalo en el siguiente campo</p>
                <input type='password' value={code} onChange={(e) => setCode(e.target.value)} className="mentoria-otp__main__input" placeholder='Digita el código' />
                {error && <p className='mentoria-otp__main__error'>{error}</p>}
                <MentoriaIconTitle width={21} text={`Reenviar código en ${Math.floor(timer / 60) + ':' + (timer % 60 < 10 ? '0' : '') + Math.round(timer % 60)} minutos`} src={props.otpIcons[0]} />
            </main>
            <div className="mentoria-otp__buttons">
                <Button text="Reenviar código" classname='' gtmMark='primary' isDisabled={timer > 0} type="button" onClickAction={getTokenOtp} />
                <Button text="Validar código" classname='' gtmMark='secondary' isDisabled={false} type="button" onClickAction={checkOtp} />
            </div>
        </div>
    )
}

export default MentoriaOtp